<template>
  <div class="home">
    <FoodTable />
    <v-spacer></v-spacer>
    <CreateFoodDialog></CreateFoodDialog>
  </div>
</template>

<script>
// @ is an alias to /src
import FoodTable from '@/components/FoodTable.vue';
import CreateFoodDialog from '@/components/CreateFoodDialog';
export default {
  name: 'Home',
  components: {
    FoodTable,
    CreateFoodDialog,
  },
};
</script>
